export default __webpack_public_path__ + "static/media/33.bf1d15ca.png";